module.exports = __webpack_public_path__ + "static/work-c85bf86ce02698e898ccf6389cd57fe5.png";